import React from 'react';
import { Section, Typography, Spinner } from 'components/base';
import withAuth from 'ecommerce/hoc/withAuth';
import useUserContext from 'ecommerce/context/user';
import {
  AUTH_PROVIDER,
  DeleteAcount,
  UserAuthProviders,
  UserAvatarSettings,
  AccountLayout,
} from 'ecommerce/components';
import { formatDate, parseDate } from 'utils/format';

import { Head, Layout } from '../../components/layout';
import SignInPage from '../signin';

const UserPage = () => {
  const userContext = useUserContext();

  return (
    <>
      <Head title="Account - Personal Info" />

      <Layout>
        <Section>
          <AccountLayout title="Personal Info">
            {userContext.isLoading ? (
              <div className="text-center">
                <Spinner />
              </div>
            ) : (
              <>
                <UserAvatarSettings accessToken={userContext.accessToken} className="mb-4" />

                {userContext.data.email && (
                  <Typography.P>
                    Contact e-mail: <strong>{userContext.data.email}</strong>
                  </Typography.P>
                )}
                {userContext.data.name && (
                  <Typography.P>
                    Name: <strong>{userContext.data.name}</strong>
                  </Typography.P>
                )}
                <Typography.P>
                  User Identifier: <strong>{userContext.data.id}</strong>
                </Typography.P>
                {userContext.data.created_at && (
                  <Typography.P>
                    Registered:{' '}
                    <strong>
                      {formatDate(parseDate(userContext.data.created_at), 'MMM Do, YYYY')}
                    </strong>
                  </Typography.P>
                )}

                {userContext.data.authentication_providers && (
                  <UserAuthProviders
                    accessToken={userContext.accessToken}
                    providers={userContext.data.authentication_providers}
                    availableProviders={[
                      AUTH_PROVIDER.AMAZON,
                      AUTH_PROVIDER.ANCESTRY,
                      AUTH_PROVIDER.FAMILY_SEARCH,
                      // AUTH_PROVIDER.FACEBOOK,
                    ]}
                    onReload={userContext.reload}
                    className="mt-5"
                  />
                )}

                <DeleteAcount
                  accessToken={userContext.accessToken}
                  buttonType="danger"
                  className="mt-5"
                />

                <Typography.P className="mt-5 text-center">
                  For further questions, please ask us at{' '}
                  <a href="mailto:help@mycanvas.com">help@mycanvas.com</a>.
                </Typography.P>
              </>
            )}
          </AccountLayout>
        </Section>
      </Layout>
    </>
  );
};

export default withAuth(UserPage, SignInPage);
